// extracted by mini-css-extract-plugin
export var alertIcon = "_q1-0";